const prod = process.env.NODE_ENV === 'production'

// const image_proxy_url = process.env.NEXT_PUBLIC_WEBAPP_IMAGE_ADDRESS

// function to stringify url image to pass in image proxy 
export function useImageProxy(url: string, enabled: boolean): string {
  if (!prod || !enabled || !url || url == 'undefined') {
    return url
  }
  let value = `/image/${url.replace('/image/', '')}`
  return value
}

